import { queryApi } from "lib/api";
import {
    OrderDetailParams,
    OrderDetailResponse,
    OrderHistoryParams,
    OrderHistoryResponse,
    OrderMerchantUidParams,
    OrderMerchantUidResponse,
    ShippingAddressParams,
    ShippingAddressResponse,
} from "./type";

export const getShippingAddress = (
    data: ShippingAddressParams
): Promise<ShippingAddressResponse> => queryApi("mint/address/list", data);

export const callOrderMerchantUidApi = (
    data: OrderMerchantUidParams
): Promise<OrderMerchantUidResponse> => queryApi("/mint/order/uid", data);

export const callOrderHistoryApi = (
    data: OrderHistoryParams
): Promise<OrderHistoryResponse> => queryApi("/mint/order/list", data);

export const callOrderDetailApi = (
    data: OrderDetailParams
): Promise<OrderDetailResponse> => queryApi("/mint/order/get", data);

// test data
// export const OrderDetailResponseTestData = {
//     access_token: "1111",
//     channel: "app",
//     server_timestamp: "1111100",
//     status: 200,
//     result_message: "success",
//     command: {
//         order_id: 1, // 주문아이디
//         merchant_uid: "10133956", // 주문코드
//         order_status: 8, // 주문상태 DeliveryState
//         delivery_method: 3, // (추가) 픽업/배송방식,  0 빠른 픽업/배송, 1 택배 *
//         mint_complete_date: 160963540, // 민트완료일시, timestamp, 없을때는 null
//         reg_date: 160835675, // 결제일(주문날짜), timestamp
//         item_list: [
//             {
//                 item_id: 343,
//                 category_name: "신발",
//                 material_name: "스니커즈",
//                 image: {
//                     before: [
//                         "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRQzhFqP1j5oW-JOlYNO4lQxPGC_B198dGKqw&usqp=CAU",
//                     ],
//                     after: [],
//                 },
//                 image_path:
//                     "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRQzhFqP1j5oW-JOlYNO4lQxPGC_B198dGKqw&usqp=CAU",
//                 service_name: ["일반 클리닝", "부분접착", "토쉐입 복원"],
//                 item_comment: "",
//                 expected_date: 0,
//                 reg_date: 0,
//                 item_price: 160000,
//                 item_status: 2,
//                 reviews_yn: 0,
//             },
//             {
//                 item_id: 344,
//                 category_name: "신발",
//                 material_name: "스니커즈",
//                 image: {
//                     before: [
//                         "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ2gDrlr8XNczsoEzjJ60Te4_qLOfghKpCp8g&usqp=CAU",
//                     ],
//                     after: [],
//                 },
//                 image_path:
//                     "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ2gDrlr8XNczsoEzjJ60Te4_qLOfghKpCp8g&usqp=CAU",
//                 service_name: [
//                     "일반 클리닝",
//                     "부분도색",
//                     "부분접착",
//                     "스티치 복원",
//                     "스크래치 복원",
//                     "안감 복원",
//                     "아웃솔 보강",
//                 ],
//                 item_comment: "",
//                 expected_date: 0,
//                 reg_date: 0,
//                 item_price: 270000,
//                 item_status: 0,
//                 reviews_yn: 0,
//             },
//         ],
//         pickup: {
//             address_name: "회사",
//             address_phone: "01091191901",
//             address: "삼성로",
//             address_detail: "302호",
//             post_num: "608325",
//             sido: "서울시",
//             sigungu: "강남구",
//             sigungu_code: "13082",
//             comment:
//                 "픽업하신 후 문자 별도로 주시면 감사하겠습니다. 공동 입구 비밀번호는 1310입니다.",
//             delivery_method: 3,
//             untact_yn: 0,
//             courier_id: 1,
//             courier_name: "CJ대한통운",
//             invoice_num: "6865278650282",
//             reservation_date: 1677155092,
//             complete_date: 1677155092,
//             delivery_state: 2,
//         },
//         delivery: {
//             address_name: "회사",
//             address_phone: "01091191901",
//             address: "삼성로",
//             address_detail: "302호",
//             post_num: "608325",
//             sido: "서울시",
//             sigungu: "강남구",
//             sigungu_code: "13082",
//             comment:
//                 "픽업하신 후 문자 별도로 주시면 감사하겠습니다. 공동 입구 비밀번호는 1310입니다.",
//             delivery_method: 3,
//             untact_yn: 1,
//             courier_id: 1,
//             courier_name: "CJ대한통운",
//             invoice_num: "6865278650282",
//             reservation_date: null, // 1677155092,
//             complete_date: 1677500692,
//             delivery_state: 2,
//         },
//         // null,
//         payment: {
//             order_amount: 10300,
//             delivery_fee: 10000,
//             discount_amount: 0,
//             cancel_amount: 0,
//             card_name: "kb",
//             card_quota: 0,
//             payment_amount: 10300,
//             total_amount: 20300,
//         },
//     },
// };
